<script setup lang="ts">
  import type { INavigationItem } from '@/components/common/ElNavigation/elNavigation';
  import ElNavigation from '@/components/common/ElNavigation/ElNavigation.vue';
  import ElNavigationItem from '@/components/common/ElNavigation/ElNavigationItem.vue';

  defineOptions({ name: 'HorizontalNavigation' });

  defineProps<{
    items: INavigationItem[];
    matchExact?: boolean;
    wideItems?: boolean;
  }>();
</script>

<template>
  <ElNavigation horizontal>
    <ElNavigationItem
      v-for="(item, index) of items"
      :key="index"
      active-class="border-b-[3px] border-b-black font-bold text-black"
      v-bind="item"
      :class="{ 'flex-1 basis-auto': wideItems }"
      link-classes="pb-4 md:pb-5"
      :match-exact="matchExact"
    />
  </ElNavigation>
</template>
